<template>
	<div class="PageChannel">
		<transition name="PageGroupTranstion" enter-active-class="animated PageGroupFadeIn">
			<div>
				<FieldForm
				@save="save"
				:cancelable="false"
				:isnew="false"
				:formfields="channel.page">
				</FieldForm>
				<router-view></router-view>
			</div>
		</transition>
	</div>
</template>

<script>
import FieldForm from '@/components/form/FieldForm';
import help_rest from '@/helpers/rest';
export default {
	name: 'PageChannel',
	components: {
		FieldForm
	},
	computed: {
		channel(){
			return this.$store.getters.channel;
		}
	},
	methods: {
		...help_rest,
		save(payload){
			var self = this;
			self.restpatch('/api/v1/channel/' + this.channel.id, payload, 'channel');
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/PageChannel.vue